<template>
  <ion-page>
    <master-layout pageTitle="حواله های ارسالی">
        <ion-card-content>
          <div class="space-between">
            <div>
              <date-input  placeholder="از تاریخ.." v-model="s_date"></date-input>
            </div>
            <div >
              <date-input  placeholder="تا تاریخ.." v-model="e_date"></date-input>
            </div>
          </div>
          <div>
            <select class="form-control" name="status" v-model="status">
              <option value="send">درحال ارسال</option>
              <option value="deliver">تحویل شده</option>
              <option value="not_deliver">تحویل نشده</option>
            </select>
          </div>
          <DataTable card="true" auto-reload="1" v-if="route" :headers="headers" :route="route"></DataTable>
        </ion-card-content>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
   IonCardContent, IonPage
} from "@ionic/vue";
import DateInput from "@/components/DateInput.vue";


export default {
  data()
  {
    return {
      id: null,
      status: null,
      s_date: null,
      e_date: null,
      route: null,
      headers:[
        'شماره',
        'نام مشتری',
          'تاریخ ثبت',
        'وضعیت',
        'امکانات'
      ]
    };
  },
  async created()
  {
    // this.id = this.$route.params.id;
    this.status = this.$route.query.status;
    // this.route = 'order/ListAjax';
   this.init();
  },
  components: {
    DateInput,
     IonCardContent, DataTable, IonPage
  },
  methods:{
    init(){
      const status = this.status;
      const s_date = this.s_date;
      const e_date = this.e_date;
      let route ='sendOrder/ListAjax?t=1';
      if (status)
        route+='&status='+status;
      if (s_date)
        route+='&s_date='+s_date;
      if (e_date)
        route+='&e_date='+e_date;
      this.route = route;


    },
  },
  watch: {
    status : function (){
      this.route = null;
      this.init();
    },
    s_date: {
      handler(){
        this.init();
      }
    },
    e_date: {
      handler(){
        this.init();
      }
    }
  }
};
</script>

<style scoped>
.space-between
{
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}
.space-between .label
{
  min-width: 30%;
}

</style>